import * as actionTypes from './actionTypes'

const task = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.TASKS_SET_VIEWED:
      return {
        ...state,
        viewed: true,
      };
    default:
      return state;
  }
};

export const tasks = (state = {
  data: null,
  isFetching: true,
  error: null,
  didInvalidate: false,
}, action) => {
  switch (action.type) {
    case actionTypes.TASKS_REQUEST:
      return {
        ...state,
        isFetching: true,
        didInvalidate: false,
        error: null,
      };
    case actionTypes.TASKS_RECEIVE:
      return {
        ...state,
        data: action.data,
        isFetching: false,
        didInvalidate: false,
        error: null,
      };
    case actionTypes.TASKS_ERROR:
      return {
        ...state,
        isFetching: false,
        didInvalidate: false,
        error: action.error,
      };
    case actionTypes.TASKS_INVALIDATE:
      return {
        ...state,
        didInvalidate: true,
        error: null,
      };
    case actionTypes.TASKS_SET_VIEWED:
      {
        return {
          ...state,
          data: {
            ...state.data,
            tasks: state.data.tasks.map(t => t.id === action.id ? task(t, action) : t),
          }
        };
      }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/tasks/reducers.js